var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DeliveryOptionContent',_vm._g(_vm._b({attrs:{"option":_vm.option,"extra-message-items":[
		{ icon: 'mdi-clock', text: _vm.option.data.openingHours },
		{ icon: 'mdi-phone', text: _vm.option.data.phone },
		{ icon: 'mdi-email', text: _vm.option.data.email } ],"show-to-address-line":""}},'DeliveryOptionContent',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }